import { REVIEW_STRUCTURE, MODULE_CRITS, ModuleCrits, ReviewStructure, Crit } from '@hydra/utils/reviewStructure';
import { CRITERIA } from '@hydra/utils/criteria';
import hasCritData from '@hydra/utils/hasCritData';
import { CriteriumInterface } from '@hydra/types/review';

export function getCriteriaModules () {
  return Object.keys(REVIEW_STRUCTURE).reduce(
    (modules: { type: string, criteria: string[] }[], section: string) => {
      return modules.concat(Object.keys(REVIEW_STRUCTURE[section as keyof ReviewStructure]).map(type => ({
        type,
        criteria: REVIEW_STRUCTURE[section as keyof ReviewStructure][type as keyof (ReviewStructure['on_page'] | ReviewStructure['off_page'])]
      })));
    },
    []
  );
}

function getValidModuleCriteria ({
  moduleCriteria,
  criteria,
  isFree,
  isLeadgen,
  loadProjectOnlyCris,
  onpageReviewFilter
}: {
  moduleCriteria: string[]
  criteria: { [key: string]: CriteriumInterface }
  isFree?: boolean
  isLeadgen?: boolean
  loadProjectOnlyCris?: boolean
  onpageReviewFilter?: string | null
}) {
  return moduleCriteria.filter(crit => {
    if (isFree) {
      if (!isLeadgen && CRITERIA[crit].isCta) {
        return true;
      }
      if (!CRITERIA[crit].isFree) {
        return false;
      }
    }

    if (onpageReviewFilter) {
      return hasCritData(criteria[crit]) && criteria[crit].status === onpageReviewFilter;
    }

    if (loadProjectOnlyCris && CRITERIA[crit].isProjectOnly) {
      return true;
    }

    return hasCritData(criteria[crit]);
  });
}

export function getReviewStructure ({
  criteria,
  isFree = false,
  isLeadgen = false,
  loadProjectOnlyCris = false,
  onpageReviewFilter = null
}: {
  criteria: { [key: string]: CriteriumInterface }
  isFree?: boolean
  isLeadgen?: boolean
  loadProjectOnlyCris?: boolean
  onpageReviewFilter?: string | null
}) {
  if (!criteria) {
    return {};
  }

  return Object.keys(REVIEW_STRUCTURE).reduce(
    (reviewStructure: { [key: string]: { [key: string]: string[] } }, section: string) => {
      const modulesStructure = Object.keys(REVIEW_STRUCTURE[section as keyof ReviewStructure]).reduce(
        (modulesStructure: { [key: string]: string[] }, module: string) => {
          const moduleCriteria = getValidModuleCriteria({
            moduleCriteria: REVIEW_STRUCTURE[section as keyof ReviewStructure][module as keyof (ReviewStructure['on_page'] | ReviewStructure['off_page'])],
            criteria,
            isFree,
            isLeadgen,
            loadProjectOnlyCris,
            onpageReviewFilter
          });
          if (moduleCriteria && moduleCriteria.length > 0) {
            modulesStructure[module] = moduleCriteria;
          }
          return modulesStructure;
        },
        {}
      );
      if (Object.keys(modulesStructure).length > 0) {
        reviewStructure[section] = modulesStructure;
      }
      return reviewStructure;
    },
    {}
  );
}

export function getSections () {
  return Object.keys(REVIEW_STRUCTURE);
}

export function getModules () {
  return Object.keys(MODULE_CRITS);
}

export function getCritetia () {
  return Object.keys(MODULE_CRITS).reduce((crits: string[], module: string) => [...crits, ...MODULE_CRITS[module as keyof ModuleCrits]], []);
}

export function getProjectCriteria () {
  return Object.keys(CRITERIA).filter(crit => CRITERIA[crit].isProjectOnly);
}

export function getVisibilityForDuda (crit: Crit) {
  return CRITERIA[crit]?.showInDudaEditor;
}

export function isShownDudaAdvice (crit: string) {
  return CRITERIA[crit]?.showExtraAdviceForDudaEditor;
}
